import { Button, Input } from "@material-tailwind/react";
import AspectRatioDiv from "components/utils/AspectRatioDiv";
import useObject from "hooks/useObject";
import React, { useContext, useEffect, useRef, useState } from "react";
import SimpleBar from "simplebar-react";
import { ReactSetterType } from "utils/types";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Tiptap from "components/Tiptap";
import { useFloating } from "@floating-ui/react-dom-interactions";
import GalleryPicker from "components/GalleryPicker";
import { useScroll } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import debounce from "lodash.debounce";
import ContentHeightContext from "contexts/ContentHeightContext";
import useResizeObserver from "@react-hook/resize-observer";
import resolveImgUrl from "utils/resolveImgUrl";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import { AlertContext } from "contexts/AlertProvider";
import Spinner from "components/utils/Spinner";
import { Businesses } from "utils/types";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMapEvents,
} from "react-leaflet";
import L, { divIcon } from 'leaflet';
import { LeafletEvent, LeafletMouseEvent } from "leaflet";
//@ts-ignore
import markerIcon from 'leaflet/dist/images/marker-icon.png';

const markerIconConst = L.icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon,
  iconAnchor: [12, 41],
  popupAnchor: [10, -44],
  iconSize: [24, 41],
});

type gallery = [string | null, (string | null)?][];

type BusinessConstructorType = {
  title: string;
  description: string;
  longitude: string;
  latitude: string;
  phone : string;
};

type BusinessData = {
  id: number | null;
  title: string;
  longitude: number | null;
  latitude: number | null;
  phone : string;
};

type Prop = {
  setMenuOpened: ReactSetterType<boolean>;
  selected: number | null;
};

function LeafletEventComponent({ onClick, latlng }: { onClick: (e: any) => void, latlng : L.LatLng | null }) {
  const map = useMapEvents({
    click(e) {
      onClick(e);
    },
  });
  useEffect(()=>{
    if(latlng)
      map.setView(latlng, map.getZoom(), {
        animate: true,
      })
  }, [latlng])
  return null;
}

const PaymentBusinessMenu = ({ setMenuOpened, selected }: Prop) => {
  const [data, setObject, setData] = useObject<BusinessData>({
    id: null,
    title: "",
    longitude: null,
    latitude: null,
    phone : ""
  });

  const axiosPrivate = useAxiosPrivate();
  const queryClient = useQueryClient();
  const { setAlert } = useContext(AlertContext);

  useEffect(() => {
    selected &&
      axiosPrivate
        .get(`/businesses/${selected}`)
        .then(({ data: _data }) => {
          const {
            description,
            geom,
            ...data
          } /*: Businesses.withUserName*/ = _data;

          setDescription(description);
          setData({
            ...data,
            longitude: parseFloat(geom.longitude),
            latitude: parseFloat(geom.latitude),
          });
        })
        .catch((err) => {
          setAlert(
            "error",
            "Cannot fetch bussines, contact admin for further information"
          );
        });
  }, [selected]);

  function postHandler(data: BusinessConstructorType & { id: number | null }) {
    if (!data.id) return axiosPrivate.post("businesses", data);
    else return axiosPrivate.put(`businesses/${data.id}`, data);
  }

  function handleLatLong(dataKey: "latitude" | "longitude") {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
      const newChar = e.target.value[e.target.value.length - 1];
      const dotFound = (data[dataKey] + "").match(/.{0,1}\../); //find if there is already comma

      //SUPER hacky way (Very bad) to enable user adding comma (disabling parse float when user add comma)
      //TODO: find better way to input float
      if (
        (newChar === "," || newChar === ".") &&
        (data[dataKey] + "").length < e.target.value.length &&
        (data[dataKey] + "")[(data[dataKey] + "").length - 1] !== "." &&
        !dotFound
      )
        //@ts-ignore
        setObject({ [dataKey]: data[dataKey] + "." });
      else setObject({ [dataKey]: parseFloat(e.target.value || "0") });
    };
  }
  const { mutate: postBusiness, isLoading } = useMutation(postHandler, {
    onSuccess() {
      queryClient.invalidateQueries(["businesses"]);

      if (!data.id) setAlert("success", "Business Posted !");
      else setAlert("success", "Business Updated !");

      setMenuOpened(false);
    },
    onError(err: any) {
      setAlert(
        "error",
        (err.message + " contact admin for further detail") as string
      );
    },
  });

  const root = useRef<HTMLDivElement>(null);
  const isMobile = useMediaQuery({ query: "(max-width: 960px)" });

  const gallerySimplebar = useRef<SimpleBar>(null);
  const gallery = useRef<HTMLDivElement>(null);

  const [description, setDescription] = useState("");

  const [overlayHeight, setOverlayHeight] = useState<string | undefined>(
    undefined
  );

  const { height: contentHeight } = useContext(ContentHeightContext);

  if (selected && !data.id)
    return (
      <div
        className="absolute left-0 top-0 w-full"
        style={{ height: contentHeight }}
      >
        <div className="sticky z-10 top-0 left-0 w-full h-screen">
          <div className="relative w-full h-full">
            <div
              className="absolute top-0 left-0 w-full h-full bg-black opacity-30 z-[11]"
              style={{ height: overlayHeight }}
              onClick={() => setMenuOpened(false)}
            ></div>
            <div className="absolute top-0 left-0 w-full h-full z-[12] grid place-content-center">
              <Spinner></Spinner>
            </div>
          </div>
        </div>
      </div>
    );
  else
    return (
      <div
        className="absolute left-0 top-0 w-full"
        style={{ height: contentHeight }}
      >
        <div className="sticky z-10 top-0 left-0 w-full h-screen">
          <div className="relative w-full h-full">
            <SimpleBar className="z-[11] h-screen" id="create-menu-simplebar">
              <div
                className="w-full h-full flex my-10 lg:my-0 lg:items-center justify-center"
                ref={root}
              >
                <div
                  className="absolute top-0 left-0 w-full lg:h-full bg-black opacity-30 z-[11]"
                  style={{ height: overlayHeight }}
                  onClick={() => setMenuOpened(false)}
                ></div>
                <div className="w-[85%] lg:h-[85%] relative z-[11]">
                    <div className="h-full w-full flex flex-col lg:flex-row gap-2">
                      <div className="w-full lg:w-72 xl:w-80 2xl:w-[30rem] flex flex-col items-center gap-y-2 relative">
                        <div className="w-full p-3 bg-white rounded-lg grow">
                          <MapContainer
                            doubleClickZoom={false}
                            center={
                              data.longitude && data.latitude
                                ? [data.latitude, data.longitude]
                                : [-6.880651887695739, 111.65146886631499]
                            }
                            zoom={13}
                            scrollWheelZoom={false}
                            className="w-full h-full"
                          >
                            <TileLayer
                              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            {data.latitude && data.longitude && (
                              <Marker
                                icon={markerIconConst}
                                position={[data.latitude, data.longitude]}
                              />
                            )}
                          </MapContainer>
                        </div>
                        <div className="w-full p-3 bg-white rounded-lg flex flex-col gap-y-3">
                          <Input
                            label="Business name"
                            tabIndex={2}
                            value={data.title}
                            disabled
                          />
                          <Input
                            label="Latitude"
                            tabIndex={3}
                            value={data.latitude || ""}
                            disabled
                          />
                          <Input
                            label="Longitude"
                            tabIndex={4}
                            value={data.longitude || ""}
                            disabled
                          />
                          <Input
                            label="Phone"
                            tabIndex={4}
                            value={`0${data.phone}`}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="bg-white rounded-lg grow lg:h-full">
                        <textarea
                          className="w-full h-full p-3 resize-none"
                          placeholder="Description"
                          onChange={(e) => setDescription(e.target.value)}
                          value={description}
                          disabled
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
            </SimpleBar>
          </div>
        </div>
      </div>
    );
};

export default PaymentBusinessMenu;
